import InfoIcon from "@mui/icons-material/Info";
import { Tooltip, Typography } from "@mui/material";
import { WorklistValues } from "features/WorklistTools/shared/interfaces";
import { useEffect, useState } from "react";
import styled from "styled-components";

const StyledMinimumFinalTubeVolumeDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 10px;
`;

interface MinFinalWellVolumeProps {
  int1ToDest: WorklistValues[];
}

export const MinFinalWellVolume = ({ int1ToDest }: MinFinalWellVolumeProps) => {
  const [minWellVolume, setMinWellVolume] = useState(0);

  useEffect(() => {
    let highestTransferVol = -1;
    for (const wellMapping of int1ToDest) {
      if (
        wellMapping.transferVol &&
        parseInt(wellMapping.transferVol) > highestTransferVol
      ) {
        highestTransferVol = parseInt(wellMapping.transferVol);
      }
    }

    if (highestTransferVol !== minWellVolume) {
      setMinWellVolume(highestTransferVol);
    }
  }, [int1ToDest]);

  const getMinWellVolumeString =
    minWellVolume > -1 ? `${minWellVolume}µL` : "N/A";

  return (
    <StyledMinimumFinalTubeVolumeDiv>
      <Typography variant="h6">{`Minimum Final Well Volume: ${getMinWellVolumeString}`}</Typography>
      <Tooltip
        title={
          "Pulled from the destination well with the highest transfer volume"
        }
      >
        <InfoIcon sx={{ alignSelf: "flex-start", marginTop: "3px" }} />
      </Tooltip>
    </StyledMinimumFinalTubeVolumeDiv>
  );
};
